export default "__VITE_ASSET__BeG_cFVq__"